import { render } from "./AuthSignUp.vue?vue&type=template&id=0cc79a21"
import script from "./AuthSignUp.vue?vue&type=script&lang=js"
export * from "./AuthSignUp.vue?vue&type=script&lang=js"

import "./AuthSignUp.vue?vue&type=style&index=0&id=0cc79a21&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__